module.exports = "<div class=ws-carousel-slide ng-class=$ctrl.getSlideClass() ng-transclude aria-hidden=\"{{ !$ctrl.amIActive() }}\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/carousel/slide/slide.tmpl.html
// module id = 99
// module chunks = 0